import React from 'react';

export const DvOtvirZText = () => {
  return (
    <p>
      Використовується як евакуаційній вихід або як запасний евакуаційний вихід. На плані необхідно позначити усі двері,
      навіть ті, якими зазвичай не користуються. <br /> Клацніть лiвою кнопкою миші на значок і перетягніть на стіну
      зовнішню
    </p>
  );
};
